module.exports = __webpack_public_path__ + "static/media/jude.86ffda97.jpg";